import { useRouter } from 'expo-router';
import useConfirmPassword from 'features/myVaro/hooks/useConfirmPassword';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SetPassword from 'shared/components/PasswordChangeForm/SetPassword';

const SetPasswordScreen = () => {
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'changePassword',
  });
  const {
    fetching,
    completePasswordChanges,
    isErrorShown,
    errorDetails,
    setIsErrorScreenShown,
  } = useConfirmPassword();

  const dialogContent = isErrorShown
    ? { title: errorDetails.defaultTitle, message: errorDetails.errorResponse }
    : undefined;

  const handleSubmit = async (password: string): Promise<void> => {
    await completePasswordChanges(password);
  };

  const router = useRouter();

  return (
    <SetPassword
      title={translatedText('title')}
      header={translatedText('header')}
      newPasswordLabel={translatedText('labels.newPassword')}
      confirmPasswordLabel={translatedText('labels.cnfNewPassword')}
      confirmPasswordErrorLabel={translatedText('labels.passwordNotMatch')}
      submitButtonLabel={translatedText('title')}
      onSubmit={handleSubmit}
      loading={fetching}
      dialogContent={dialogContent}
      onDialogClose={() => setIsErrorScreenShown(false)}
      onBack={router.back}
      tryAgainAction={() => setIsErrorScreenShown(false)}
      showErrorScreen={true}
    />
  );
};

export default SetPasswordScreen;
